import {
  LayoutDashboard, Layers, Users, FileText, TrendingUp, Search, GitCompare, Leaf, BookOpen, ListTodo, Store, GraduationCap, Sunrise
} from 'lucide-react';

export const navItemKeys = [
  { to: '/briefing', icon: Sunrise, key: 'nav_briefing', testId: 'nav-briefing', code: 'HOME' },
  { to: '/dashboard', icon: LayoutDashboard, key: 'nav_dashboard', testId: 'nav-dashboard', code: 'DASH' },
  { to: '/worklist', icon: ListTodo, key: 'nav_worklist', testId: 'nav-worklist', mod: 'worklist', code: 'WORK' },
  { to: '/pipeline', icon: Layers, key: 'nav_pipeline', testId: 'nav-pipeline', mod: 'pipeline', code: 'PIPE' },
  { to: '/institutions', icon: Users, key: 'nav_institutions', testId: 'nav-institutions', mod: 'institutions', code: 'INST' },
  { to: '/marketplace', icon: Store, key: 'nav_marketplace', testId: 'nav-marketplace', mod: 'marketplace', code: 'MKT' },
  { to: '/impact', icon: Leaf, key: 'nav_impact', testId: 'nav-impact', mod: 'impact', code: 'IMPT' },
  { to: '/knowledge', icon: BookOpen, key: 'nav_knowledge', testId: 'nav-knowledge', mod: 'knowledge', code: 'KNOW' },
  { to: '/formation', icon: GraduationCap, key: 'nav_formation', testId: 'nav-formation', mod: 'formation', code: 'TRN' },
  { to: '/search', icon: Search, key: 'nav_search', testId: 'nav-search', mod: 'search', code: 'SRCH' },
  { to: '/analytics', icon: TrendingUp, key: 'nav_analytics', testId: 'nav-analytics', mod: 'analytics', code: 'ANLY' },
  { to: '/compare', icon: GitCompare, key: 'nav_compare', testId: 'nav-compare', mod: 'compare', code: 'CMP' },
  { to: '/submit-project', icon: FileText, key: 'nav_submit', testId: 'nav-submit-project', accent: true, code: 'NEW' },
];

export const isNavVisible = (item, user) => {
  const mods = Array.isArray(user?.enabled_modules) ? user.enabled_modules : null;
  return !item.mod || !mods || mods.includes(item.mod);
};
